import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { CODEMASTER_CONFIG } from './base/codemaster-config';

export const codemasterRoutes: Routes = [
  {
    path: CODEMASTER_CONFIG.routePath,
    canActivate: [roleGuard('ADMIN_SYSTEM')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/codemaster-list-page/codemaster-list-page.component'
          ).then((m) => m.CodemasterListPageComponent),
        canActivate: [roleGuard('ADMIN_SYSTEM')],
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/codemaster-detail-page/codemaster-detail-page.component'
              ).then((m) => m.CodemasterDetailPageComponent),
          },
        ],
      },
    ],
  },
];
